import React, { Component } from 'react';
import { Spinner, Modal } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import compose from 'lodash.flowright';
import { getStampClass as defaultStampClass, getDefaultStatusName } from './doubtDeskStyles';
import { formatDoubtTime } from './doubtHelpers';

const GET_DOUBT_TRACKING = gql`
  query($doubt_id: Int!) {
    getDoubtTracking(doubt_id: $doubt_id) {
      id
      answer
      image_path
      name
      doubts_user_type
      timestamp
      is_seen
      is_liked
      rating
    }
  }
`;

const ADD_DOUBT_ANSWER = gql`
  mutation($params: DoubtTrackingInput!) {
    addDoubtAnswer(params: $params)
  }
`;

const MARK_DOUBT_AS_SEEN = gql`
  mutation($doubt_id: Int!) {
    markDoubtAsSeen(doubt_id: $doubt_id)
  }
`;

const UPDATE_DOUBT = gql`
  mutation($doubt_id: Int!, $title: String!, $description: String!) {
    updateDoubt(doubt_id: $doubt_id, title: $title, description: $description)
  }
`;

const UPDATE_DOUBT_TRACKING_ANSWER = gql`
  mutation($tracking_id: Int!, $answer: String!) {
    updateDoubtTrackingAnswer(tracking_id: $tracking_id, answer: $answer)
  }
`;

const UPDATE_DOUBT_FEEDBACK = gql`
  mutation($tracking_id: Int!, $is_liked: String, $rating: String) {
    updateDoubtTrackingFeedback(tracking_id: $tracking_id, is_liked: $is_liked, rating: $rating)
  }
`;

const COMPLETE_DOUBT = gql`
  mutation($doubt_id: Int!) {
    completeDoubt(doubt_id: $doubt_id)
  }
`;

const REOPEN_DOUBT = gql`
  mutation($doubt_id: Int!) {
    reopenDoubt(doubt_id: $doubt_id)
  }
`;

const DELETE_DOUBT = gql`
  mutation($doubt_id: Int!) {
    deleteDoubt(doubt_id: $doubt_id)
  }
`;

const DELETE_DOUBT_TRACKING_ANSWER = gql`
  mutation($tracking_id: Int!) {
    deleteDoubtTrackingAnswer(tracking_id: $tracking_id)
  }
`;

const FILE_UPLOAD_MUTATION = gql`
  mutation($params: FileUploadInput!) {
    fileUpload(params: $params) {
      file_url
      uuid
    }
  }
`;

const CHAT_CSS = `
/* ---- chat head ---- */
.doubt-desk .ddc-head {
    padding:12px 16px; border-bottom:1px solid var(--dd-border);
    border-left:4px solid var(--dd-accent); background:var(--dd-surface-alt);
    display:flex; justify-content:space-between; align-items:flex-start; gap:14px; flex-shrink:0;
}
.doubt-desk .ddc-head-left { min-width:0; }
.doubt-desk .ddc-head-left h3 { font-size:.95rem; font-weight:700; margin:0; color:var(--dd-text); }
.doubt-desk .ddc-meta { display:flex; gap:12px; align-items:center; margin-top:4px; flex-wrap:wrap; }
.doubt-desk .ddc-meta span { font-size:.68rem; color:var(--dd-faint); }
.doubt-desk .ddc-link {
    background:none; border:none; padding:0; cursor:pointer; font-family:inherit;
    font-size:.72rem; font-weight:700; color:var(--dd-accent);
}
.doubt-desk .ddc-link:hover { color:var(--dd-accent-dark); text-decoration:underline; }
.doubt-desk .ddc-head-right {
    display:flex; flex-direction:row-reverse; align-items:center; justify-content:flex-end;
    flex-wrap:wrap; gap:10px; flex-shrink:0;
}
.doubt-desk .ddc-resolve-btn {
    display:inline-flex; align-items:center; gap:6px; white-space:nowrap;
    background:var(--dd-surface); border:1px solid #a3e9d7; color:#0f9d68;
    font-family:inherit; font-size:.72rem; font-weight:700;
    padding:6px 12px; border-radius:20px; cursor:pointer; transition:all .15s ease;
}
.doubt-desk .ddc-resolve-btn:hover { background:#e6f9f4; border-color:#0f9d68; }
.doubt-desk .ddc-reask-btn {
    display:inline-flex; align-items:center; gap:6px; white-space:nowrap;
    background:var(--dd-surface); border:1px solid var(--dd-accent-line); color:var(--dd-accent-dark);
    font-family:inherit; font-size:.72rem; font-weight:700;
    padding:6px 12px; border-radius:20px; cursor:pointer; transition:all .15s ease;
}
.doubt-desk .ddc-reask-btn:hover:not(:disabled) { background:var(--dd-accent-tint); border-color:var(--dd-accent); }
.doubt-desk .ddc-reask-btn:disabled { opacity:.6; cursor:default; }
.doubt-desk .ddc-resolve-confirm {
    display:flex; align-items:center; gap:10px; font-size:.72rem; color:var(--dd-text-soft);
    background:var(--dd-surface); border:1px solid var(--dd-border); border-radius:20px; padding:5px 12px;
}
.doubt-desk .ddc-link-green { color:#0f9d68; }
.doubt-desk .ddc-link-green:hover { color:#0b7a51; }
.doubt-desk .ddc-link:disabled { opacity:.5; cursor:default; }
.doubt-desk .ddc-back {
    display:none; background:var(--dd-surface); border:1px solid var(--dd-border-strong);
    color:var(--dd-text-soft); font-family:inherit; font-size:.7rem; font-weight:700;
    padding:4px 12px; border-radius:15px; cursor:pointer; margin-bottom:6px;
}

/* ---- messages ---- */
.doubt-desk .ddc-body {
    flex:1; overflow-y:auto; padding:18px 20px; display:flex; flex-direction:column; gap:14px; min-height:0;
}
.doubt-desk .ddc-msg { max-width:78%; display:flex; flex-direction:column; gap:3px; }
.doubt-desk .ddc-msg.student { align-self:flex-end; align-items:flex-end; }
.doubt-desk .ddc-msg.faculty { align-self:flex-start; align-items:flex-start; }
.doubt-desk .ddc-bubble-head {
    display:flex; align-items:center; justify-content:space-between; gap:14px; margin-bottom:6px;
}
.doubt-desk .ddc-sender { font-size:.75rem; font-weight:700; }
.doubt-desk .ddc-msg.student .ddc-sender { color:#1a8754; }
.doubt-desk .ddc-msg.faculty .ddc-sender { color:#3730a3; }
.doubt-desk .ddc-role { font-weight:500; color:#8a8f98; }
.doubt-desk .ddc-bubble-actions { display:flex; align-items:center; gap:4px; flex-shrink:0; }
.doubt-desk .ddc-icon-btn {
    background:none; border:none; padding:2px 4px; cursor:pointer; font-size:.72rem; line-height:1;
    opacity:.8; transition:opacity .15s ease, color .15s ease;
}
.doubt-desk .ddc-icon-btn:hover:not(:disabled) { opacity:1; }
.doubt-desk .ddc-icon-btn:disabled { opacity:.4; cursor:default; }
.doubt-desk .ddc-icon-btn { color:#e6a23c; }
.doubt-desk .ddc-icon-btn:hover:not(:disabled) { color:#c8871f; }
.doubt-desk .ddc-icon-danger { color:#e05252; }
.doubt-desk .ddc-icon-danger:hover:not(:disabled) { color:#c62828; }
.doubt-desk .ddc-bubble-foot {
    display:flex; align-items:center; justify-content:flex-end; gap:6px; margin-top:6px; font-size:.65rem;
}
.doubt-desk .ddc-bubble-foot { color:#8a9aa5; }
.doubt-desk .ddc-seen { font-size:.7rem; }
.doubt-desk .ddc-seen.sent { color:#9aa8b2; }
.doubt-desk .ddc-seen.read { color:#4caf50; }
.doubt-desk .ddc-confirm {
    display:flex; align-items:center; flex-wrap:wrap; gap:10px; margin-top:8px;
    padding-top:8px; font-size:.72rem; border-top:1px solid #ece6dd;
}
.doubt-desk .ddc-msg.student .ddc-confirm { border-top-color:#c8ecb4; }
.doubt-desk .ddc-bubble {
    padding:10px 14px; border-radius:12px; font-size:.88rem; line-height:1.45; word-break:break-word;
    box-shadow:0 1px 2px rgba(15,23,42,.12); animation:dd-fade-in-up .25s ease-out forwards;
}
.doubt-desk .ddc-msg.student .ddc-bubble {
    background:#dcf8c6; color:#1e293b; border:1px solid #c8ecb4; border-bottom-right-radius:4px;
}
.doubt-desk .ddc-msg.faculty .ddc-bubble {
    background:#ffffff; color:#1e293b; border:1px solid #ece6dd; border-bottom-left-radius:4px;
}
@keyframes dd-fade-in-up {
    from { opacity:0; transform:translateY(10px); }
    to { opacity:1; transform:translateY(0); }
}
.doubt-desk .ddc-bubble img {
    max-width:100%; max-height:220px; border-radius:6px; display:block; cursor:zoom-in;
}
.doubt-desk .ddc-wait {
    align-self:center; font-size:.72rem; color:var(--dd-faint); padding:6px 0;
}
.doubt-desk .ddc-edit-link {
    background:none; border:none; padding:0; cursor:pointer; text-decoration:underline;
    font-family:inherit; font-size:.68rem; font-weight:600; color:var(--dd-muted);
}
.doubt-desk .ddc-inline-edit { display:flex; flex-direction:column; gap:8px; min-width:190px; }
.doubt-desk .ddc-inline-edit-wide { min-width:min(340px, 60vw); }
.doubt-desk .ddc-inline-actions { display:flex; justify-content:flex-end; gap:12px; }
.doubt-desk .ddc-inline-edit .dd-field { border:1px solid var(--dd-border); background:#ffffff; }
.doubt-desk .ddc-inline-edit textarea.dd-field { resize:vertical; }
.doubt-desk .ddc-edit-link:disabled { opacity:.5; cursor:default; }

/* ---- feedback chips ---- */
.doubt-desk .ddc-feedback { display:flex; align-items:center; gap:8px; margin-top:4px; flex-wrap:wrap; padding:0 4px; }
.doubt-desk .ddc-chip {
    font-family:inherit; font-size:.68rem; font-weight:600; padding:3px 10px; border-radius:20px;
    border:1px solid; cursor:pointer; background:transparent;
}
.doubt-desk .ddc-chip-up { color:#00C596; border-color:#a3e9d7; background:#e6f9f4; }
.doubt-desk .ddc-chip-down { color:#dc3545; border-color:#f5c2c2; background:#fce8e8; }
.doubt-desk .ddc-chip-star { color:var(--dd-amber); border-color:var(--dd-amber-line); background:#fffbeb; }
.doubt-desk .ddc-chip-rate { color:var(--dd-accent); border-color:var(--dd-accent-line); background:var(--dd-accent-tint); }
.doubt-desk .ddc-chip-rate:hover { background:var(--dd-accent-soft); }

/* ---- signoff ---- */
.doubt-desk .ddc-signoff {
    align-self:center; margin:6px 0; text-align:center; font-size:.7rem; font-weight:600;
    color:var(--dd-green); border:1px solid var(--dd-green-line); background:var(--dd-green-bg);
    border-radius:20px; padding:5px 16px;
}

/* ---- empty / loading ---- */
.doubt-desk .ddc-empty {
    flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px;
    color:var(--dd-faint); font-size:.85rem; text-align:center; padding:40px;
}
.doubt-desk .ddc-empty .dd-glyph { font-size:2.4rem; color:var(--dd-border-strong); line-height:1; }

/* ---- jump to latest ---- */
.doubt-desk .ddc-jump {
    position:absolute; right:22px; bottom:84px; z-index:3;
    width:38px; height:38px; border-radius:50%; border:none; cursor:pointer;
    background:rgba(15,23,42,.78); color:#ffffff; font-size:.85rem;
    display:flex; align-items:center; justify-content:center;
    box-shadow:0 4px 12px rgba(15,23,42,.28);
    animation:dd-fade-in-up .2s ease-out forwards; transition:background .15s ease;
}
.doubt-desk .ddc-jump:hover { background:rgba(15,23,42,.92); }

/* ---- composer ---- */
.doubt-desk .ddc-input {
    display:flex; gap:10px; align-items:flex-end; padding:12px 16px;
    background:transparent; flex-shrink:0;
}
.doubt-desk .ddc-compose-field {
    flex:1; display:flex; align-items:flex-end; gap:4px; min-width:0;
    background:#ffffff; border:1px solid #e6e0d7; border-radius:26px;
    padding:4px 10px 4px 6px; box-shadow:0 1px 2px rgba(15,23,42,.06);
    transition:border-color .15s ease, box-shadow .15s ease;
}
.doubt-desk .ddc-compose-field:focus-within {
    border-color:#c8ecb4; box-shadow:0 0 0 3px rgba(34,197,94,.12);
}
.doubt-desk .ddc-compose-field.locked {
    background:#f4f1ec; border-color:#e6e0d7; box-shadow:none;
}
.doubt-desk .ddc-compose-field.locked textarea { cursor:not-allowed; }
.doubt-desk .ddc-compose-field.locked .ddc-attach { cursor:not-allowed; opacity:.5; }
.doubt-desk .ddc-input textarea {
    flex:1; min-width:0; resize:none; border:none; background:transparent; box-shadow:none;
    padding:10px 6px; font-family:inherit; font-size:.9rem; color:var(--dd-text);
    min-height:36px; max-height:120px; outline:none;
}
.doubt-desk .ddc-input textarea::placeholder { color:#9aa3ad; }
.doubt-desk .ddc-attach {
    background:none; border:none; border-radius:50%; cursor:pointer;
    width:38px; height:38px; font-size:1rem; color:#8a9aa5; flex-shrink:0;
    display:flex; align-items:center; justify-content:center; transition:all .15s ease;
}
.doubt-desk .ddc-attach:hover:not(:disabled) { background:#f4f1ec; color:#5a6b7f; }
.doubt-desk .ddc-send {
    width:46px; height:46px; border-radius:50%; border:none; flex-shrink:0;
    background:#22c55e; color:#ffffff; font-size:1rem; cursor:pointer;
    display:flex; align-items:center; justify-content:center;
    box-shadow:0 4px 12px rgba(34,197,94,.35); transition:all .2s ease-in-out;
}
.doubt-desk .ddc-send:hover:not(:disabled) { background:#16a34a; }
.doubt-desk .ddc-send:disabled { opacity:.5; cursor:default; box-shadow:none; }
.doubt-desk .ddc-preview-strip {
    padding:10px 16px 0; display:flex; align-items:center; gap:10px;
}
.doubt-desk .ddc-preview-strip img {
    height:44px; border-radius:6px; border:1px solid #e6e0d7;
    background:#ffffff; object-fit:contain;
}
.doubt-desk .ddc-note {
    font-size:.75rem; color:#dc3545; padding:8px 16px 0;
}

@media (max-width: 767.98px) {
    .doubt-desk .ddc-back { display:inline-block; }
    .doubt-desk .ddc-msg { max-width:88%; }
}

/* ---- rating modal (rendered outside .doubt-desk) ---- */
.dd-rating-modal .modal-content { border:none; border-radius:12px; box-shadow:0 10px 40px rgba(15,23,42,.15); }
.dd-rating-modal .modal-header { border-bottom:1px solid #f1f5f9; padding:12px 16px; }
.dd-rating-modal .modal-title { font-size:.95rem; font-weight:700; color:#0f172a; }
.dd-rating-modal .modal-body { padding:16px; }
.dd-rating-modal .modal-footer { border-top:1px solid #f1f5f9; padding:10px 16px; }
.dd-rating-modal .ddm-quote {
    background:#f8fafc; border:1px solid #e2e8f0; border-radius:8px; padding:10px 12px;
    font-size:.78rem; color:#475569; max-height:85px; overflow-y:auto; margin-bottom:16px; line-height:1.45;
}
.dd-rating-modal .ddm-quote b { color:#0f172a; display:block; margin-bottom:4px; font-size:.78rem; }
.dd-rating-modal .ddm-label {
    font-size:.82rem; font-weight:700; color:#64748b; margin-bottom:8px; text-align:center;
}
.dd-rating-modal .ddm-row { display:flex; gap:10px; }
.dd-rating-modal .ddm-vote {
    flex:1; border:1px solid #e2e8f0; background:#f8fafc; border-radius:20px; padding:8px 12px;
    font-size:.8rem; font-weight:600; color:#475569; cursor:pointer; transition:all .2s ease;
}
.dd-rating-modal .ddm-vote.up-on { border-color:#00C596; color:#00C596; background:#e6f9f4; }
.dd-rating-modal .ddm-vote.down-on { border-color:#dc3545; color:#dc3545; background:#fce8e8; }
.dd-rating-modal .ddm-stars { display:flex; justify-content:center; gap:4px; }
.dd-rating-modal .ddm-star { cursor:pointer; font-size:1.8rem; line-height:1; transition:all .2s ease; }
.dd-rating-modal .ddm-divider { border-top:1px solid #e2e8f0; margin:16px 0; }
.dd-rating-modal .ddm-done {
    width:100%; background:linear-gradient(135deg,#4f6bed 0%,#1e80ce 100%); color:#ffffff;
    border:none; border-radius:8px; padding:9px; font-weight:700; font-size:.85rem; cursor:pointer;
}
.dd-rating-modal .ddm-done:hover { background:linear-gradient(135deg,#4cb0ff 0%,#2992e4 100%); }

/* ---- image viewer (rendered outside .doubt-desk) ---- */
.dd-image-modal .modal-content { background:transparent; border:none; box-shadow:none; }
.dd-image-modal .ddi-wrap {
    position:relative; background:#0f172a; border-radius:12px; overflow:hidden;
    box-shadow:0 20px 60px rgba(15,23,42,.45);
}
.dd-image-modal .ddi-scroll {
    max-height:80vh; overflow:auto; text-align:center; line-height:0;
}
.dd-image-modal .ddi-scroll img {
    max-width:100%; max-height:80vh; cursor:zoom-in; display:inline-block;
}
.dd-image-modal .ddi-scroll img.zoomed {
    max-width:none; max-height:none; width:200%; cursor:zoom-out;
}
.dd-image-modal .ddi-close, .dd-image-modal .ddi-zoom {
    position:absolute; top:10px; z-index:2; width:34px; height:34px; border:none; border-radius:50%;
    background:rgba(15,23,42,.65); color:#ffffff; cursor:pointer; line-height:1;
    display:flex; align-items:center; justify-content:center;
}
.dd-image-modal .ddi-close { right:12px; font-size:1.4rem; }
.dd-image-modal .ddi-zoom { right:54px; font-size:.85rem; }
.dd-image-modal .ddi-close:hover, .dd-image-modal .ddi-zoom:hover { background:rgba(15,23,42,.9); }
`;
class DoubtTracking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reply: '',
            file: null,
            filePreviewUrl: '',
            fileError: '',
            submitting: false,
            errorMsg: '',
            activeRatingTrackId: null,
            isEditingDoubt: false,
            editTitle: '',
            editDescription: '',
            savingDoubt: false,
            editingMessageId: null,
            editingMessageText: '',
            savingMessage: false,
            deleteTarget: null,   // 'doubt' | tracking id
            deleting: false,
            lightboxUrl: null,
            imageZoomed: false,
            showJumpDown: false,
            completing: false,
            confirmComplete: false,
            reopening: false
        };
    }

    // "jump to latest" appears once the thread is scrolled away from the bottom
    handleBodyScroll = (e) => {
        const el = e.target;
        const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 120;
        if (this.state.showJumpDown === nearBottom) {
            this.setState({ showJumpDown: !nearBottom });
        }
    }

    jumpToBottom = () => {
        if (!this.chatContainerRef) return;
        if (this.chatContainerRef.scrollTo) {
            this.chatContainerRef.scrollTo({ top: this.chatContainerRef.scrollHeight, behavior: 'smooth' });
        } else {
            this.chatContainerRef.scrollTop = this.chatContainerRef.scrollHeight;
        }
    }

    openImage = (url) => {
        this.setState({ lightboxUrl: url, imageZoomed: false });
    }

    closeImage = () => {
        this.setState({ lightboxUrl: null, imageZoomed: false });
    }

    // Student closes the doubt: status 3 + is_clarified '1', which is what the
    // faculty side reads. Sending another message reopens it (see addDoubtAnswer).
    handleCompleteDoubt = async () => {
        this.setState({ completing: true });
        try {
            await this.props.completeDoubt({
                variables: { doubt_id: parseInt(this.props.doubt.id) }
            });
            if (this.props.refetchDoubts) this.props.refetchDoubts();
            if (this.props.getDoubtTracking) this.props.getDoubtTracking.refetch();
        } catch (error) {
            console.error("Error completing doubt:", error);
            alert("Failed to mark the doubt as resolved: " + error.message);
        } finally {
            this.setState({ completing: false, confirmComplete: false });
        }
    }

    // Re-ask: the closed thread goes back to Pending, history intact.
    handleReopenDoubt = async () => {
        this.setState({ reopening: true });
        try {
            await this.props.reopenDoubt({
                variables: { doubt_id: parseInt(this.props.doubt.id) }
            });
            if (this.props.refetchDoubts) this.props.refetchDoubts();
            if (this.props.getDoubtTracking) this.props.getDoubtTracking.refetch();
        } catch (error) {
            console.error("Error reopening doubt:", error);
            alert("Failed to re-ask the doubt: " + error.message);
        } finally {
            this.setState({ reopening: false });
        }
    }

    // Deletes are soft: the row's estatus goes to '0' and the queries stop returning it.
    handleDeleteDoubt = async () => {
        this.setState({ deleting: true });
        try {
            await this.props.deleteDoubt({
                variables: { doubt_id: parseInt(this.props.doubt.id) }
            });
            this.setState({ deleteTarget: null });
            if (this.props.refetchDoubts) this.props.refetchDoubts();
            if (this.props.onClose) this.props.onClose();
        } catch (error) {
            console.error("Error deleting doubt:", error);
            alert("Failed to delete doubt: " + error.message);
        } finally {
            this.setState({ deleting: false });
        }
    }

    handleDeleteMessage = async (tracking_id) => {
        this.setState({ deleting: true });
        try {
            await this.props.deleteDoubtTrackingAnswer({
                variables: { tracking_id: parseInt(tracking_id) }
            });
            this.setState({ deleteTarget: null });
            if (this.props.getDoubtTracking) this.props.getDoubtTracking.refetch();
            if (this.props.refetchDoubts) this.props.refetchDoubts();
        } catch (error) {
            console.error("Error deleting message:", error);
            alert("Failed to delete message: " + error.message);
        } finally {
            this.setState({ deleting: false });
        }
    }

    handleStartEditDoubt = () => {
        const { doubt } = this.props;
        this.setState({
            isEditingDoubt: true,
            editTitle: doubt.title || '',
            editDescription: doubt.description || ''
        });
    }

    handleCancelEditDoubt = () => {
        this.setState({ isEditingDoubt: false });
    }

    handleSaveEditDoubt = async () => {
        const { editTitle, editDescription } = this.state;
        if (!editTitle.trim() || !editDescription.trim()) return;

        this.setState({ savingDoubt: true });
        try {
            await this.props.updateDoubt({
                variables: {
                    doubt_id: parseInt(this.props.doubt.id),
                    title: editTitle.trim(),
                    description: editDescription.trim()
                }
            });
            this.setState({ isEditingDoubt: false });
            if (this.props.refetchDoubts) {
                this.props.refetchDoubts();
            }
        } catch (error) {
            console.error("Error updating doubt:", error);
            alert("Failed to update doubt: " + error.message);
        } finally {
            this.setState({ savingDoubt: false });
        }
    }

    handleSaveEditMessage = async (tracking_id) => {
        const { editingMessageText } = this.state;
        if (!editingMessageText.trim()) return;

        this.setState({ savingMessage: true });
        try {
            await this.props.updateDoubtTrackingAnswer({
                variables: {
                    tracking_id: parseInt(tracking_id),
                    answer: editingMessageText.trim()
                }
            });
            this.setState({ editingMessageId: null, editingMessageText: '' });
            if (this.props.getDoubtTracking) {
                this.props.getDoubtTracking.refetch();
            }
        } catch (error) {
            console.error("Error saving edited message:", error);
            alert("Failed to save message: " + error.message);
        } finally {
            this.setState({ savingMessage: false });
        }
    }

    componentDidMount() {
        this.scrollToBottom();
        this.markAsSeen();
    }

    markAsSeen = async () => {
        try {
            await this.props.markDoubtAsSeen({
                variables: { doubt_id: parseInt(this.props.doubt.id) }
            });
            if (this.props.refetchDoubts) {
                this.props.refetchDoubts();
            }
        } catch (error) {
            console.error("Error marking doubt as seen:", error);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const prevTracking = prevProps.getDoubtTracking && prevProps.getDoubtTracking.getDoubtTracking ? prevProps.getDoubtTracking.getDoubtTracking : [];
        const currentTracking = this.props.getDoubtTracking && this.props.getDoubtTracking.getDoubtTracking ? this.props.getDoubtTracking.getDoubtTracking : [];

        if (prevTracking.length !== currentTracking.length || prevProps.getDoubtTracking.loading !== this.props.getDoubtTracking.loading) {
            this.scrollToBottom();
        }
    }

    scrollToBottom = () => {
        if (this.chatContainerRef) {
            this.chatContainerRef.scrollTop = this.chatContainerRef.scrollHeight;
        }
    }

    handleReplyChange = (e) => {
        this.setState({ reply: e.target.value });
    }

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            this.handleRemoveFile();
            return;
        }

        if (!file.type.startsWith('image/')) {
            this.setState({ file: null, fileError: 'Please upload image files only', filePreviewUrl: '' });
            e.target.value = '';
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            this.setState({ file: null, fileError: 'Image size must be less than 5MB', filePreviewUrl: '' });
            e.target.value = '';
            return;
        }

        this.setState({ file: file, fileError: '', filePreviewUrl: URL.createObjectURL(file) });
    }

    handleRemoveFile = () => {
        if (this.state.filePreviewUrl) {
            URL.revokeObjectURL(this.state.filePreviewUrl);
        }
        this.setState({ file: null, filePreviewUrl: '', fileError: '' });
        if (this.fileInputRef) {
            this.fileInputRef.value = '';
        }
    }

    handleFeedback = async (tracking_id, is_liked, rating) => {
        try {
            await this.props.updateDoubtTrackingFeedback({
                variables: {
                    tracking_id: parseInt(tracking_id),
                    is_liked: is_liked !== undefined ? is_liked.toString() : undefined,
                    rating: rating !== undefined ? rating.toString() : undefined
                }
            });
            if (this.props.getDoubtTracking) {
                this.props.getDoubtTracking.refetch();
            }
        } catch (error) {
            console.error("Error updating feedback:", error);
        }
    }

    submitReply = async (e) => {
        e.preventDefault();
        // a resolved doubt is read-only until the student re-asks it
        if (this.props.doubt && this.props.doubt.doubt_status == 3) return;
        if (!this.state.reply.trim() && !this.state.file) return;

        this.setState({ submitting: true, errorMsg: '' });
        try {
            let image_path = "";

            if (this.state.file) {
                const base64File = await this.getBase64(this.state.file);
                const uploadRes = await this.props.fileUpload({
                    variables: {
                        params: {
                            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                            category: "materials",
                            client_id: 1,
                            file: [{ img: base64File, filename: this.state.file.name }]
                        }
                    }
                });
                if (uploadRes?.data?.fileUpload?.length > 0) {
                    image_path = uploadRes.data.fileUpload[0].file_url;
                }
            }

            await this.props.addDoubtAnswer({
                variables: {
                    params: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                        doubts_id: parseInt(this.props.doubt.id),
                        answer: this.state.reply.trim() || " ", // fallback to space if empty
                        name: Cookies.get("studentusername") || "Student",
                        image_path: image_path,
                        doubts_user_type: 1,
                        estatus: 1
                    }
                }
            });

            this.setState({ reply: '' });
            this.handleRemoveFile();
            if (this.props.getDoubtTracking) {
                this.props.getDoubtTracking.refetch();
            }
        } catch (error) {
            console.error("Error submitting reply:", error);
            this.setState({ errorMsg: "Failed to send message: " + error.message });
        } finally {
            this.setState({ submitting: false });
        }
    }

    render() {
        const doubt = this.props.doubt;
        const tracking = this.props.getDoubtTracking && this.props.getDoubtTracking.getDoubtTracking ? this.props.getDoubtTracking.getDoubtTracking : [];
        const loading = this.props.getDoubtTracking && this.props.getDoubtTracking.loading;

        const facultyReplies = tracking.filter(t => t.doubts_user_type !== 1);
        const lastFacultyReplyId = facultyReplies.length > 0 ? facultyReplies[facultyReplies.length - 1].id : null;

        // The details page mounts this component without the register helpers
        const stampClass = this.props.getStampClass || defaultStampClass;
        const statusName = this.props.getStatusName || getDefaultStatusName;

        if (!doubt) {
            return <div className="ddc-empty">Doubt not found or loading...</div>;
        }

        const isResolved = doubt.doubt_status == 3;
        const resolvedAt = facultyReplies.length > 0
            ? facultyReplies[facultyReplies.length - 1].timestamp
            : doubt.timestamp;
        const askedAt = formatDoubtTime(doubt.raised_time || doubt.timestamp);

        return (
            <React.Fragment>
                <style>{CHAT_CSS}</style>

                {/* ---------- head ---------- */}
                <div className="ddc-head">
                    <div className="ddc-head-left">
                        <button className="ddc-back" onClick={this.props.onClose}>&#8592; Back</button>

                        <h3>{doubt.title}</h3>
                        <div className="ddc-meta">
                            <span>{doubt.subject_name || 'General'}</span>
                            {askedAt && <span>Asked {askedAt}</span>}
                        </div>
                    </div>
                    <div className="ddc-head-right">
                        <span className={stampClass(doubt.doubt_status)}>
                            {statusName(doubt.doubt_status)}
                        </span>
                        {isResolved && (
                            <button
                                className="ddc-reask-btn"
                                onClick={this.handleReopenDoubt}
                                disabled={this.state.reopening}
                                title="Ask this doubt again"
                            >
                                <i className="fas fa-redo" /> {this.state.reopening ? 'Re-asking...' : 'Re-ask this doubt'}
                            </button>
                        )}
                        {!isResolved && (
                            this.state.confirmComplete ? (
                                <div className="ddc-resolve-confirm">
                                    <span>Is your doubt cleared?</span>
                                    <button
                                        className="ddc-link"
                                        onClick={() => this.setState({ confirmComplete: false })}
                                        disabled={this.state.completing}
                                    >
                                        Not yet
                                    </button>
                                    <button
                                        className="ddc-link ddc-link-green"
                                        onClick={this.handleCompleteDoubt}
                                        disabled={this.state.completing}
                                    >
                                        {this.state.completing ? 'Saving...' : 'Yes, close it'}
                                    </button>
                                </div>
                            ) : (
                                <button
                                    className="ddc-resolve-btn"
                                    onClick={() => this.setState({ confirmComplete: true })}
                                    title="Tell the faculty this doubt is cleared"
                                >
                                    <i className="fas fa-check" /> Mark as resolved
                                </button>
                            )
                        )}
                    </div>
                </div>

                {/* ---------- conversation ---------- */}
                <div className="ddc-body" ref={el => this.chatContainerRef = el} onScroll={this.handleBodyScroll}>
                    {/* the doubt itself opens the thread */}
                    <div className="ddc-msg student">
                        <div className="ddc-bubble">
                            <div className="ddc-bubble-head">
                                <span className="ddc-sender">
                                    You<span className="ddc-role"> · Question</span>
                                </span>
                                {!this.state.isEditingDoubt && (
                                    <span className="ddc-bubble-actions">
                                        <button
                                            className="ddc-icon-btn"
                                            title="Edit doubt"
                                            onClick={this.handleStartEditDoubt}
                                            disabled={this.state.deleting}
                                        >
                                            <i className="fas fa-pen" />
                                        </button>
                                        <button
                                            className="ddc-icon-btn ddc-icon-danger"
                                            title="Delete doubt"
                                            onClick={() => this.setState({ deleteTarget: 'doubt' })}
                                            disabled={this.state.deleting}
                                        >
                                            <i className="fas fa-trash-alt" />
                                        </button>
                                    </span>
                                )}
                            </div>
                            {doubt.image_path && (
                                <img
                                    src={doubt.image_path}
                                    alt="Doubt attachment"
                                    style={{ marginBottom: '8px' }}
                                    onClick={() => this.openImage(doubt.image_path)}
                                    title="Click to zoom"
                                />
                            )}
                            {this.state.isEditingDoubt ? (
                                <div className="ddc-inline-edit ddc-inline-edit-wide">
                                    <input
                                        type="text"
                                        className="dd-field"
                                        value={this.state.editTitle}
                                        onChange={(e) => this.setState({ editTitle: e.target.value })}
                                        placeholder="Doubt title"
                                    />
                                    <textarea
                                        className="dd-field"
                                        rows={3}
                                        value={this.state.editDescription}
                                        onChange={(e) => this.setState({ editDescription: e.target.value })}
                                        placeholder="Describe your doubt in detail..."
                                    />
                                    <div className="ddc-inline-actions">
                                        <button
                                            className="ddc-edit-link"
                                            onClick={this.handleCancelEditDoubt}
                                            disabled={this.state.savingDoubt}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="ddc-edit-link"
                                            onClick={this.handleSaveEditDoubt}
                                            disabled={this.state.savingDoubt || !this.state.editTitle.trim() || !this.state.editDescription.trim()}
                                        >
                                            {this.state.savingDoubt ? 'Saving...' : 'Save'}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <div>{doubt.description}</div>
                                    {this.state.deleteTarget === 'doubt' && (
                                        <div className="ddc-confirm">
                                            <span>Delete this doubt and its replies?</span>
                                            <button
                                                className="ddc-edit-link"
                                                onClick={() => this.setState({ deleteTarget: null })}
                                                disabled={this.state.deleting}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="ddc-edit-link"
                                                onClick={this.handleDeleteDoubt}
                                                disabled={this.state.deleting}
                                            >
                                                {this.state.deleting ? 'Deleting...' : 'Delete'}
                                            </button>
                                        </div>
                                    )}
                                    <div className="ddc-bubble-foot">
                                        <span>{askedAt}</span>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>

                    {loading && tracking.length === 0 ? (
                        <div className="ddc-wait">
                            <Spinner animation="border" size="sm" variant="primary" />
                        </div>
                    ) : tracking.length === 0 ? (
                        <div className="ddc-wait">Waiting for the faculty to respond...</div>
                    ) : (
                        <React.Fragment>
                            {tracking.map(track => {
                                const isStudent = track.doubts_user_type === 1;
                                const isEditing = this.state.editingMessageId === track.id;

                                return (
                                    <div key={track.id} className={`ddc-msg ${isStudent ? 'student' : 'faculty'}`}>
                                        <div className="ddc-bubble">
                                            <div className="ddc-bubble-head">
                                                <span className="ddc-sender">
                                                    {isStudent ? 'You' : (track.name || 'Faculty')}
                                                    <span className="ddc-role"> · {isStudent ? 'Student' : 'Faculty'}</span>
                                                </span>
                                                {isStudent && !isEditing && (
                                                    <span className="ddc-bubble-actions">
                                                        <button
                                                            className="ddc-icon-btn"
                                                            title="Edit message"
                                                            onClick={() => this.setState({ editingMessageId: track.id, editingMessageText: track.answer })}
                                                            disabled={this.state.deleting}
                                                        >
                                                            <i className="fas fa-pen" />
                                                        </button>
                                                        <button
                                                            className="ddc-icon-btn ddc-icon-danger"
                                                            title="Delete message"
                                                            onClick={() => this.setState({ deleteTarget: track.id })}
                                                            disabled={this.state.deleting}
                                                        >
                                                            <i className="fas fa-trash-alt" />
                                                        </button>
                                                    </span>
                                                )}
                                            </div>
                                            {track.image_path && (
                                                <img
                                                    src={track.image_path}
                                                    alt="Attachment"
                                                    style={{ marginBottom: '8px' }}
                                                    onClick={() => this.openImage(track.image_path)}
                                                    title="Click to zoom"
                                                />
                                            )}
                                            {isEditing ? (
                                                <div className="ddc-inline-edit">
                                                    <textarea
                                                        className="dd-field"
                                                        rows={2}
                                                        value={this.state.editingMessageText}
                                                        onChange={(e) => this.setState({ editingMessageText: e.target.value })}
                                                    />
                                                    <div className="ddc-inline-actions">
                                                        <button
                                                            className="ddc-edit-link"
                                                            onClick={() => this.setState({ editingMessageId: null, editingMessageText: "" })}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="ddc-edit-link"
                                                            onClick={() => this.handleSaveEditMessage(track.id)}
                                                        >
                                                            {this.state.savingMessage ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>{track.answer}</div>
                                            )}
                                            {this.state.deleteTarget === track.id && (
                                                <div className="ddc-confirm">
                                                    <span>Delete this message?</span>
                                                    <button
                                                        className="ddc-edit-link"
                                                        onClick={() => this.setState({ deleteTarget: null })}
                                                        disabled={this.state.deleting}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className="ddc-edit-link"
                                                        onClick={() => this.handleDeleteMessage(track.id)}
                                                        disabled={this.state.deleting}
                                                    >
                                                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                                                    </button>
                                                </div>
                                            )}
                                            {!isEditing && (
                                                <div className="ddc-bubble-foot">
                                                    <span>{formatDoubtTime(track.timestamp)}</span>
                                                    {isStudent && (() => {
                                                        // double tick only once the faculty has answered after this message
                                                        const answered = lastFacultyReplyId !== null &&
                                                            Number(lastFacultyReplyId) > Number(track.id);
                                                        return (
                                                            <i
                                                                className={`fas ${answered ? 'fa-check-double ddc-seen read' : 'fa-check ddc-seen sent'}`}
                                                                title={answered ? 'Answered by faculty' : 'Sent'}
                                                            />
                                                        );
                                                    })()}
                                                </div>
                                            )}
                                        </div>

                                        {!isStudent && (() => {
                                            const isLastFacultyReply = lastFacultyReplyId !== null && track.id === lastFacultyReplyId;
                                            const hasFeedback = track.is_liked === '1' || track.is_liked === '0' || (track.rating && track.rating !== '0');

                                            if (!hasFeedback && !isLastFacultyReply) return null;

                                            return (
                                                <div className="ddc-feedback">
                                                    {hasFeedback ? (
                                                        <React.Fragment>
                                                            {track.is_liked === '1' && (
                                                                <button
                                                                    className="ddc-chip ddc-chip-up"
                                                                    onClick={() => this.setState({ activeRatingTrackId: track.id })}
                                                                    title="Click to edit rating"
                                                                >
                                                                    Helpful
                                                                </button>
                                                            )}
                                                            {track.is_liked === '0' && (
                                                                <button
                                                                    className="ddc-chip ddc-chip-down"
                                                                    onClick={() => this.setState({ activeRatingTrackId: track.id })}
                                                                    title="Click to edit rating"
                                                                >
                                                                    Not helpful
                                                                </button>
                                                            )}
                                                            {track.rating && track.rating !== '0' && (
                                                                <button
                                                                    className="ddc-chip ddc-chip-star"
                                                                    onClick={() => this.setState({ activeRatingTrackId: track.id })}
                                                                    title="Click to edit rating"
                                                                >
                                                                    {track.rating} &#9733;
                                                                </button>
                                                            )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <button
                                                            className="ddc-chip ddc-chip-rate"
                                                            onClick={() => this.setState({ activeRatingTrackId: track.id })}
                                                        >
                                                            Rate answer
                                                        </button>
                                                    )}
                                                </div>
                                            );
                                        })()}
                                    </div>
                                );
                            })}

                            {isResolved && (
                                <div className="ddc-signoff">
                                    Marked resolved &middot; {formatDoubtTime(resolvedAt)}
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>

                {this.state.showJumpDown && (
                    <button className="ddc-jump" onClick={this.jumpToBottom} title="Jump to latest">
                        <i className="fas fa-chevron-down" />
                    </button>
                )}

                {/* ---------- composer ---------- */}
                {this.state.errorMsg && <div className="ddc-note">{this.state.errorMsg}</div>}
                {this.state.fileError && <div className="ddc-note">{this.state.fileError}</div>}
                {this.state.filePreviewUrl && (
                    <div className="ddc-preview-strip">
                        <img src={this.state.filePreviewUrl} alt="Preview" />
                        <button className="ddc-link" onClick={this.handleRemoveFile}>Remove</button>
                    </div>
                )}
                <form className="ddc-input" onSubmit={this.submitReply}>
                    <input
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={el => this.fileInputRef = el}
                        onChange={this.handleFileChange}
                    />
                    <div className={`ddc-compose-field ${isResolved ? 'locked' : ''}`}>
                        <button
                            type="button"
                            className="ddc-attach"
                            onClick={() => this.fileInputRef && this.fileInputRef.click()}
                            disabled={this.state.submitting || isResolved}
                            title={isResolved ? 'Re-ask the doubt to attach an image' : 'Attach image'}
                        >
                            <i className="fas fa-paperclip" />
                        </button>
                        <textarea
                            rows={1}
                            value={this.state.reply}
                            onChange={this.handleReplyChange}
                            placeholder={isResolved
                                ? "This doubt is resolved — use Re-ask this doubt to continue"
                                : "Type a message"}
                            disabled={this.state.submitting || isResolved}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    this.submitReply(e);
                                }
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        className="ddc-send"
                        title={isResolved ? 'Re-ask the doubt to send a message' : 'Send'}
                        disabled={this.state.submitting || isResolved || (!this.state.reply.trim() && !this.state.file)}
                    >
                        {this.state.submitting
                            ? <Spinner animation="border" size="sm" />
                            : <i className="fas fa-paper-plane" />}
                    </button>
                </form>

                {/* ---------- rating modal ---------- */}
                <Modal
                    show={this.state.activeRatingTrackId !== null}
                    onHide={() => this.setState({ activeRatingTrackId: null })}
                    centered
                    size="sm"
                    dialogClassName="dd-rating-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Rate faculty response</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {(() => {
                            const ratingTrack = tracking.find(t => t.id === this.state.activeRatingTrackId);
                            if (!ratingTrack) return null;
                            return (
                                <div>
                                    <div className="ddm-quote">
                                        <b>{ratingTrack.name || 'Faculty'}</b>
                                        {ratingTrack.answer}
                                    </div>

                                    <div className="ddm-label">Was this answer helpful?</div>
                                    <div className="ddm-row">
                                        <button
                                            className={`ddm-vote ${ratingTrack.is_liked === '1' ? 'up-on' : ''}`}
                                            onClick={() => this.handleFeedback(ratingTrack.id, '1', undefined)}
                                        >
                                            Yes
                                        </button>
                                        <button
                                            className={`ddm-vote ${ratingTrack.is_liked === '0' ? 'down-on' : ''}`}
                                            onClick={() => this.handleFeedback(ratingTrack.id, '0', undefined)}
                                        >
                                            No
                                        </button>
                                    </div>

                                    <div className="ddm-divider" />

                                    <div className="ddm-label">Rate this response</div>
                                    <div className="ddm-stars">
                                        {[1, 2, 3, 4, 5].map(star => (
                                            <span
                                                key={star}
                                                className="ddm-star"
                                                style={{
                                                    color: (parseInt(ratingTrack.rating) || 0) >= star ? '#ffc107' : '#cbd5e1',
                                                    transform: (parseInt(ratingTrack.rating) || 0) >= star ? 'scale(1.15)' : 'scale(1)'
                                                }}
                                                onClick={() => this.handleFeedback(ratingTrack.id, undefined, star.toString())}
                                            >
                                                &#9733;
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            );
                        })()}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="ddm-done" onClick={() => this.setState({ activeRatingTrackId: null })}>
                            Done
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* ---------- image viewer ---------- */}
                <Modal
                    show={this.state.lightboxUrl !== null}
                    onHide={this.closeImage}
                    centered
                    size="lg"
                    dialogClassName="dd-image-modal"
                >
                    <div className="ddi-wrap">
                        <button className="ddi-close" onClick={this.closeImage} title="Close">
                            &times;
                        </button>
                        <button
                            className="ddi-zoom"
                            onClick={() => this.setState({ imageZoomed: !this.state.imageZoomed })}
                            title={this.state.imageZoomed ? 'Zoom out' : 'Zoom in'}
                        >
                            <i className={`fas ${this.state.imageZoomed ? 'fa-search-minus' : 'fa-search-plus'}`} />
                        </button>
                        <div className="ddi-scroll">
                            {this.state.lightboxUrl && (
                                <img
                                    src={this.state.lightboxUrl}
                                    alt="Attachment"
                                    className={this.state.imageZoomed ? 'zoomed' : ''}
                                    onClick={() => this.setState({ imageZoomed: !this.state.imageZoomed })}
                                />
                            )}
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(GET_DOUBT_TRACKING, {
        options: props => ({
            variables: { doubt_id: parseInt(props.doubt.id) },
            fetchPolicy: "cache-and-network"
        }),
        name: "getDoubtTracking"
    }),
    graphql(ADD_DOUBT_ANSWER, {
        name: "addDoubtAnswer"
    }),
    graphql(MARK_DOUBT_AS_SEEN, {
        name: "markDoubtAsSeen"
    }),
    graphql(UPDATE_DOUBT_FEEDBACK, {
        name: "updateDoubtTrackingFeedback"
    }),
    graphql(UPDATE_DOUBT, {
        name: "updateDoubt"
    }),
    graphql(UPDATE_DOUBT_TRACKING_ANSWER, {
        name: "updateDoubtTrackingAnswer"
    }),
    graphql(COMPLETE_DOUBT, {
        name: "completeDoubt"
    }),
    graphql(REOPEN_DOUBT, {
        name: "reopenDoubt"
    }),
    graphql(DELETE_DOUBT, {
        name: "deleteDoubt"
    }),
    graphql(DELETE_DOUBT_TRACKING_ANSWER, {
        name: "deleteDoubtTrackingAnswer"
    }),
    graphql(FILE_UPLOAD_MUTATION, {
        name: "fileUpload"
    })
)(DoubtTracking);
